module.exports = __webpack_public_path__ + "static/img/ubg1.29570553.png";